.systemleverandorHeading {
  font-weight: 500;
  margin-top: var(--dds-spacing-large-48);
}

.fullmaktCheckbox {
  margin-top: var(--dds-spacing-medium-24);
}

.nesteOgTilbakeKnapper {
  margin-top: var(--dds-spacing-medium-40);
}
